module.exports = window["wc"]["wcBlocksRegistry"];